// Landing page data that is NOT copy: the accent palette, the per-feature
// gradients, and the store links. Every translated string lives in
// pages/landing/landingContent.js, so a wording change never touches a hex
// value and a palette change never touches two locales.

// Accent palette (CSS custom properties consumed across landing.css).
// Owla emerald palette (brand green → mint → deep forest).
export const accents = { acc1: '#22C07F', acc2: '#5EEAD4', acc3: '#34644C' };

// Per-feature artwork for the six cards in Features.jsx. Order matches
// `features.items` in pages/landing/landingContent.js — the copy lives there,
// with the other translated strings, and only the gradient lives here.
export const featureVisuals = [
  { icon: '\u{1F512}', c1: '#34644C', c2: '#22C07F', glow: 'rgba(52,100,76,.45)' },
  { icon: '\u{1F4AC}', c1: '#22C07F', c2: '#5EEAD4', glow: 'rgba(34,192,127,.42)' },
  { icon: '\u{1F5C2}\uFE0F', c1: '#5EEAD4', c2: '#22C07F', glow: 'rgba(94,234,212,.36)' },
  { icon: '\u{1F9F5}', c1: '#34644C', c2: '#7ED957', glow: 'rgba(126,217,87,.34)' },
  { icon: '\u{1F4CE}', c1: '#1B8F62', c2: '#5EEAD4', glow: 'rgba(27,143,98,.4)' },
  { icon: '\u2726', c1: '#D4B15A', c2: '#22C07F', glow: 'rgba(212,177,90,.28)' },
];

// ---------------------------------------------------------------------------
// DOWNLOAD LINKS
// `key` selects the glyph in glyphs.jsx (apple | windows | android).
// ---------------------------------------------------------------------------
// `meta` (the device line) and `cta` (the button) are translated — they live
// under `download.platforms[id]` in pages/landing/landingContent.js, keyed by
// the same ids used here.
export const downloads = {
  macos:   { id: 'macos',   key: 'apple',   name: 'macOS',   href: 'https://apps.apple.com/us/app/go-chat-app/id6772884814' },
  windows: { id: 'windows', key: 'windows', name: 'Windows', href: 'https://drive.google.com/drive/folders/12jEv3kBcjzeyqPrS6GJwTONFZiBbP902?hl=vi' },
  ios:     { id: 'ios',     key: 'apple',   name: 'iOS',     href: 'https://apps.apple.com/us/app/go-chat-app/id6772884814' },
  android: { id: 'android', key: 'android', name: 'Android', href: 'https://play.google.com/store/apps/details?id=com.goldenowl.gochat' },
};

export const platforms = [downloads.macos, downloads.windows, downloads.ios, downloads.android];

// Anchor props that open real store/download URLs in a new tab. In-page
// anchor links (href starting with "#") scroll in place, so they are left
// in the same tab.
export function linkTarget(href) {
  return href && !href.startsWith('#')
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};
}

// Picks the download entry that matches the visitor's current OS. Windows
// visitors get the Windows (Google Drive) build; everyone else falls back to
// macOS as a safe default.
export function getDefaultDownload() {
  if (typeof navigator !== 'undefined') {
    const ua = `${navigator.userAgent || ''} ${navigator.platform || ''}`;
    if (/Win/i.test(ua)) return downloads.windows;
  }
  return downloads.macos;
}
